export default __webpack_public_path__ + "static/media/newsletter-pb.18c9f5fb.webp";